import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import UserDataContext from "../../context/UserDataContext";

function EditUser() {
  const [error, setError] = useState(false);
  const [projekte, setProjekte] = useState([]);
  const { getLoggedIn } = useContext(AuthContext);
  const history = useHistory();
  const { id } = useParams();
  const [success, setSuccess] = useState(false);
  const token = localStorage.getItem("token");
  const { userData } = useContext(UserDataContext);
  const [recordData, setRecordData] = useState({});

  async function getUser() {
    const userRes = await axios.get(
      `${process.env.REACT_APP_BACKEND}/auth/${id}`,
      {
        headers: {
          jwttoken: token,
        },
      }
    );

    setRecordData({
      email: userRes.data.email,
      name: userRes.data.name,
      permissions: {
        isAdmin: userRes.data.permissions.isAdmin,
      },
      projekte: userRes.data.projekte,
    });
  }

  async function getProjekte() {
    const userRes = await axios.get(
      `${process.env.REACT_APP_BACKEND}/settings/projects`,
      {
        headers: {
          jwttoken: token,
        },
      }
    );
    setProjekte(userRes.data);
  }

  async function editUser(e) {
    e.preventDefault();

    console.log(recordData);

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND}/auth/edit/${id}`,
        recordData,
        {
          headers: {
            jwttoken: token,
          },
        }
      );
      await getLoggedIn();
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
      }, 4000);
    } catch (err) {
      setError(true);
    }
  }

  useEffect(() => {
    getUser();
    getProjekte();
  }, []);

  return (
    <>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg flex justify-between">
        <div className="px-4 py-5 sm:px-6 justify-start lg:w-0 lg:flex-1">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Benutzer bearbeiten
          </h3>
        </div>
      </div>
      <div className="bg-white  overflow-hidden sm:rounded-lg flex justify-center my-5">
        <div className="container flex justify-start w-full">
          <div className="flex flex-col grow">
            <div className="border-b border-gray-200 shadow overflow-hidden sm:rounded-lg">
              <form onSubmit={editUser}>
                <div className="shadow overflow-hidden sm:rounded-md">
                  <div className="px-4 py-5 bg-white sm:p-6">
                    <div className="grid grid-cols-6 gap-6">
                      <div className="col-span-3">
                        <label className="block text-sm font-medium text-gray-700">
                          Name
                        </label>
                        <input
                          type="string"
                          onChange={(e) =>
                            setRecordData({
                              ...recordData,
                              name: e.target.value,
                            })
                          }
                          value={recordData.name}
                          className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                        />
                      </div>

                      <div className="col-span-3">
                        <label className="block text-sm font-medium text-gray-700">
                          Email-Adresse
                        </label>
                        <input
                          type="email"
                          onChange={(e) =>
                            setRecordData({
                              ...recordData,
                              email: e.target.value,
                            })
                          }
                          value={recordData.email}
                          className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                        />
                      </div>
                      <div className="col-span-3">
                        <label className="block text-sm font-medium text-gray-700">
                          Neues Passwort (optional)
                        </label>
                        <input
                          type="password"
                          onChange={(e) =>
                            setRecordData({
                              ...recordData,
                              password: e.target.value,
                            })
                          }
                          value={recordData.password}
                          className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                        />
                      </div>
                      <div className="col-span-3">
                        <label className="block text-sm font-medium text-gray-700">
                          Neues Passwort bestätigen (optional)
                        </label>
                        <input
                          type="password"
                          onChange={(e) =>
                            setRecordData({
                              ...recordData,
                              passwordVerify: e.target.value,
                            })
                          }
                          value={recordData.passwordVerify}
                          className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                        />
                      </div>
                      <div className="col-span-3">
                        <div className="flex items-start">
                          <div className="flex items-center h-5">
                            <input
                              id="instandhaltung"
                              type="checkbox"
                              checked={
                                recordData.permissions
                                  ? recordData.permissions.isAdmin
                                  : false
                              }
                              className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                              onChange={(e) =>
                                setRecordData({
                                  ...recordData,
                                  permissions: {
                                    isAdmin: e.target.checked,
                                  },
                                })
                              }
                            />
                          </div>
                          <div className="ml-3 text-sm">
                            <label
                              htmlFor="instandhaltung"
                              className="font-medium text-gray-700"
                            >
                              Administrator Berechtigungen (global)
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-span-3">
                        <label className="block text-sm font-medium text-gray-700">
                          Zugewiesene Projekte
                        </label>
                        <select
                          id="projekte"
                          multiple
                          onChange={(e) =>
                            setRecordData({
                              ...recordData,
                              projekte: Array.from(
                                e.target.selectedOptions,
                                (option) => option.value
                              ),
                            })
                          }
                          value={recordData.projekte}
                          className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        >
                          {projekte.map((ks) => (
                            <option value={ks._id}>{ks.bezeichnung}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                    <button
                      type="submit"
                      className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      Speichern
                    </button>
                    {success && (
                      <div
                        className="flex rounded-md items-center bg-green-500 text-white text-sm font-bold px-4 py-3 my-5"
                        role="alert"
                      >
                        <svg
                          className="fill-current w-6 h-6 mr-3"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" />
                        </svg>
                        <p>
                          <p>Speichern erfolgreich.</p>
                        </p>
                      </div>
                    )}
                    {error && (
                      <div
                        className="flex rounded-md items-center bg-red-500 text-white text-sm font-bold px-4 py-3 my-5"
                        role="alert"
                      >
                        <svg
                          className="fill-current w-6 h-6 mr-3"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" />
                        </svg>
                        <p>
                          Fehler bei der Registrierung. Bitte überprüfen Sie
                          ihre Eingaben oder wenden Sie sich an den Support.
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditUser;
